window.galleryLightbox = function() {
  return {
    open: false,
    opened($event) {
      const img = $event.target.parentElement.querySelector('img');
      var modalImg = document.createElement('img');
      modalImg.src = img.src;
      const modalId = $event.target.dataset.modalid;
      modalImg.style.maxHeight = '90vh';
      document
        .querySelector('#modal--' + modalId + ' .content-container')
        .replaceChildren(modalImg);
      this.open = true;
    },
    expanded: false,
    expand($event) {
      const galleryId = $event.target.dataset.galleryid;
      const parentDiv = $event.target.closest('div');
      const galleryBase = parentDiv.querySelector('.gallery_items-first');
      const galleryAdditional = parentDiv.querySelector('.gallery_items-additional');

      galleryAdditional.classList.toggle('hidden');
      this.expanded = !this.expanded;
      if (this.expanded) {
        console.log($event.target);
        $event.target.innerText = $event.target.innerText.replace('Expand', 'Collapse');
        $event.target.innerText = $event.target.innerText.replace('Show', 'Hide');
      } else {
        console.log($event.target);
        $event.target.innerText = $event.target.innerText.replace('Collapse', 'Expand');
        $event.target.innerText = $event.target.innerText.replace('Hide', 'Show');
      }
    },
  };
};
